import { useTranslation } from 'react-i18next';

import TypographyV2 from '../typographyv2/typographyv2';

import { createMarkup, IFrameIsEmpty, IFrameProps } from './iframe.config';

const IFRAME_REGEX = /^<iframe[\s\S]*<\/iframe>$/;

const IFrame = ({ cqPath, iFrameContent, isInEditor }: IFrameProps) => {
  const { t } = useTranslation();

  if (IFrameIsEmpty({ cqPath, iFrameContent, isInEditor })) {
    return null;
  }

  const validationLabel = isInEditor ? (
    <TypographyV2 className="snowflake-iframe-validation" variant="body3">
      {t('iframe_validation')}
    </TypographyV2>
  ) : null;

  const isValidIframe = iFrameContent && iFrameContent.match(IFRAME_REGEX) && iFrameContent.length > 0;

  return isValidIframe ? (
    <div
      className="snowflake-iframe"
      data-testid="snowflake-iframe"
      dangerouslySetInnerHTML={createMarkup(iFrameContent)}
    ></div>
  ) : (
    validationLabel
  );
};

export default IFrame;
